import React from 'react'
import { shallowEqual, useSelector } from 'react-redux';

const Commission = ({ row }) => {
    const { amount, side, openPrice, interest, symbolId } = row;
    const symbol = useSelector(state => state.watchlist.symbols?.[symbolId])
    const symbolParameterData = useSelector((state) => state?.symbol?.allSymbolParams?.[symbolId], shallowEqual);
    const refSymbol = useSelector(state => state.updateSymbol?.symbols?.[symbol?.referenceSymbolId]) || null
    if (!symbol?.bid || !symbol?.ask) return;
    const { bid, ask } = symbol
    if (!symbolParameterData) return;
    let currentPrice = side === 1 ? bid : ask;
    const calculateRefValue = () => {

        if (!symbolParameterData) return 1; // Default value if symbolData is missing

        const { referenceSymbolCalculationType } = symbolParameterData;

        // **Check if reference symbol is USD**
        if (symbol?.referenceSymbolId == null || symbol?.referenceSymbolId == 0 || refSymbol == null) {
            return 1; // USD reference value is always 1
        }

        // **Apply reference symbol calculation type**
        return referenceSymbolCalculationType === "Division" ? 1 / currentPrice : currentPrice;
    };
    const calculateCloseCommission = () => {
        const { closeCommissionValue, closeCommissionType } = symbolParameterData;
        let currentPrice = side === 1 ? bid : ask;
        if (closeCommissionType == 0) {
            return 0
        } else if (closeCommissionType == 1) {
            return amount * symbol.contractSize * currentPrice * 0.01 * closeCommissionValue * (calculateRefValue() || 1);
        } else if (closeCommissionType == 2) {
            console.log("closeCommissionType", amount)
            return closeCommissionValue * amount;
        } else if (closeCommissionType == 3) {
            return closeCommissionValue;
        } else {
            return 0;
        }
    }

    return (<div>{(calculateCloseCommission() || 0).toFixed(2)}</div>)
}

export default Commission